module.exports = __webpack_public_path__ + "static/trust-img-3f7bcfa51a3beaacc3ffc8b08afc8449.png";